import { requestGooseAPI, getAPIPath } from '../shared/request'
import { GenericSimpleBag } from '../types/general'
import { APIBenefitConsumptionRecordClientDtoResponse } from '../types/api'
import { CLIENT_BENEFIT_CONSUMPTION_RECORDS_PATH } from '../types/constants'

export const ClientBenefitConsumptionRecordsService = {
  get: (locationId: string, locationUserProfileId: string, options?: GenericSimpleBag) =>
    requestGooseAPI<APIBenefitConsumptionRecordClientDtoResponse>({
      url: getAPIPath(CLIENT_BENEFIT_CONSUMPTION_RECORDS_PATH, { locationId }),
      method: 'GET',
      params: {
        ...options,
        includes: [
          'benefit.benefitOffers.offer',
          'locationUserProfileMembership.locationMembership',
          'locationUserProfileMembership.membership',
          'invoiceItem.invoice.locationServiceType.serviceType',
        ],
        'locationUserProfileMembership.locationUserProfileId': locationUserProfileId,
      },
    }),

  getRecordsForUsage: (locationId: string, locationUserProfileId: string, options?: GenericSimpleBag) =>
    requestGooseAPI<APIBenefitConsumptionRecordClientDtoResponse>({
      url: getAPIPath(CLIENT_BENEFIT_CONSUMPTION_RECORDS_PATH, { locationId }),
      method: 'GET',
      params: {
        ...options,
        includes: ['benefit.benefitOffers.offer', 'invoiceItem.invoice', 'locationUserProfileMembership.membership'],
        'locationUserProfileMembership.locationUserProfileId': locationUserProfileId,
      },
    }),
}
